import { useState, useEffect } from "react";
import { eventEmitter } from "../../shared/event";

interface FormDirtyListenerProps {
  onDirtyChange: (isDirty: boolean) => void;
}

const FormDirtyListener = ({ onDirtyChange }: FormDirtyListenerProps) => {
  const [, setIsDirty] = useState(false);

  useEffect(() => {
    const handleDirtyState = (dirty: boolean) => {
      setIsDirty(dirty);
      onDirtyChange(dirty); // Notify parent component
    };

    eventEmitter.addListener("IsDirtyForm", handleDirtyState); // Subscribe

    return () => {
      eventEmitter.removeListener("IsDirtyForm", handleDirtyState); // Cleanup
    };
  }, [onDirtyChange]);

  return null;
};

export default FormDirtyListener;
